// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__xoiIm","productName":"Table_productName__Fn8tA"};